import { ValidationErrors } from '@angular/forms';
import { isBefore } from 'date-fns/isBefore';

import { RoomBookingFormModel } from '@bookly/shared';

export function eventTimeValidator() {
  return (formGroup: RoomBookingFormModel): ValidationErrors | null => {
    const startDate = formGroup.controls.startDate;
    const endDate = formGroup.controls.endDate;
    const startHour = formGroup.controls.startHour;
    const endHour = formGroup.controls.endHour;

    const hoursStart = new Date(
      startDate.value.toDateString() + ' ' + startHour.value?.toTimeString()
    );
    const hoursEnd = new Date(
      endDate.value?.toDateString() + ' ' + endHour.value?.toTimeString()
    );

    const isHourBefore = isBefore(hoursStart, hoursEnd);
    const isStartInThePast = isBefore(hoursStart, new Date());

    if (isStartInThePast) {
      startHour.setErrors({ error: true });

      return { timeFromPast: true };
    }

    if (!isHourBefore) {
      startHour.setErrors({ error: true });
      endHour.setErrors({ error: true });
    } else {
      startHour.setErrors(null);
      endHour.setErrors(null);
    }

    return !isHourBefore ? { timeNotValid: true } : null;
  };
}

export function dateBeforeAYearValidator() {
  return (formGroup: RoomBookingFormModel): ValidationErrors | null => {
    const startDate = formGroup.controls.startDate.value;
    if (!startDate) {
      return null;
    }
    const isStartAfterAYear = isBefore(
      new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      startDate
    );
    if (isStartAfterAYear) {
      return { dateTooFar: true };
    }
    return null;
  };
}
